import axios from 'axios';

// Define where your token is stored in localStorage
const AUTH_TOKEN_KEY = 'AUTH_TOKEN_KEY'; // You can name this anything, e.g., 'jwtToken', 'accessToken'

const API_BASE_URL = 'https://api.meetify.co.in'//'https://backend-code-jcri.onrender.com'; // Replace with your actual API base URL

const api = axios.create({
    baseURL: API_BASE_URL,
    // headers: {
    //     'Content-Type': 'application/json',
    //     // DO NOT hardcode the token here. It will be added by the interceptor.
    // },
});

// --- Axios Request Interceptor ---
// This interceptor will run before every request made by this 'api' instance.
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem(AUTH_TOKEN_KEY);

        // If a token exists, attach it to the Authorization header
        // It's common practice to use 'Bearer' prefix for JWT tokens.
        // If your backend specifically expects 'x-auth', then use that.
        // For this example, I'll use the standard 'Authorization' header with 'Bearer'.
        // If your backend truly expects 'x-auth' without 'Bearer', just use:
        // if (token) { config.headers['x-auth'] = token; }
        console.log('Token:', token); // Debugging: log the token to console
        if (token) {
            config.headers['x-auth'] = token;
            // If your backend expects 'x-auth', use this instead:
            // config.headers['x-auth'] = token;
        }
        console.log('Request Config:', config); // Debugging: log the request config to console

        return config; // Return the modified config
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

// --- Axios Response Interceptor (Optional but Recommended) ---
// This can be used for global error handling, refreshing tokens, etc.
api.interceptors.response.use(
    (response) => response, // Just return the response if successful
    async (error) => {
        // console.error('API request failed:', error);
        // Example: Handle 401 Unauthorized errors (token expired, invalid)
        if (error.response && error.response.status === 401) {
            console.error('Unauthorized access - token might be expired or invalid.');
            // You might want to redirect to a login page here
            // window.location.href = '/login'; // Example redirection
            // Or dispatch a logout action in a Redux/Context system
        }
        return Promise.reject(error); // Re-throw the error for component-level handling
    }
);


/**
 * Centralized API service for all modules.
 * Provides a single point of interaction with the backend API.
 */
const apiService = {
    /**
     * Fetches data from a specified endpoint.
     * @param {string} endpoint - The API endpoint to fetch from.
     * @param {object} params - Optional query parameters.
     * @returns {Promise<object>} - A promise that resolves to the fetched data.
     */
    get: async (endpoint, params = {}) => {
        try {
            const response = await api.get(endpoint, { params });
            return response.data;
        } catch (error) {
            console.error(`API GET request to ${endpoint} failed:`, error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    /**
     * Sends a POST request to a specified endpoint.
     * @param {string} endpoint - The API endpoint to send the POST request to.
     * @param {object} data - The data to send in the request body.
     * @returns {Promise<object>} - A promise that resolves to the response data.
     */
    post: async (endpoint, data) => {
        try {
            const response = await api.post(endpoint, data);
            return response.data;
        } catch (error) {
            console.error(`API POST request to ${endpoint} failed:`, error);
            throw error;
        }
    },

    /**
     * Sends a PUT request to a specified endpoint.
     * @param {string} endpoint - The API endpoint to send the PUT request to.
     * @param {object} data - The data to send in the request body.
     * @returns {Promise<object>} - A promise that resolves to the response data.
     */
    put: async (endpoint, data) => {
        try {
            const response = await api.put(endpoint, data);
            return response.data;
        } catch (error) {
            console.error(`API PUT request to ${endpoint} failed:`, error);
            throw error;
        }
    },
    patch: async (endpoint, data) => {
        try {
            const response = await api.patch(endpoint, data);
            return response.data;
        } catch (error) {
            console.error(`API patch request to ${endpoint} failed:`, error);
            throw error;
        }
    },

    /**
     * Sends a DELETE request to a specified endpoint.
     * @param {string} endpoint - The API endpoint to send the DELETE request to.
     * @returns {Promise<object>} - A promise that resolves to the response data.
     */
    delete: async (endpoint) => {
        try {
            const response = await api.delete(endpoint);
            return response.data;
        } catch (error) {
            console.error(`API DELETE request to ${endpoint} failed:`, error);
            throw error;
        }
    },

    // Add more methods for other HTTP methods as needed (PATCH, etc.)
};

export default apiService;
